import React from 'react';
import {Col, Row, Spin} from 'antd';

import AccountBusinessInfoEdit from '../../../components/account/AccountBusinessInfoEdit';
import {messageType, showMessages} from '../../../helpers/message';
import AccountBusinessDetailsStaff from '../../../components/account/AccountBusinessDetailsStaff';
import PageTitle from '../../../components/page/PageTitle';
import {cardsGridColumn} from '../../../assets/styles';
import {useGetCompanyQuery} from '../../../store/api/companyApi';
import {BaseError} from '../../../types/apiTypes';
import {useAppSelector} from '../../../hooks/useStore';
import {selectCurrentProfile} from '../../../store/slices/userSlice';
import AddressCard from '../../../components/contactMethod/AddressCard';

import './AccountBusinessInfo.less';

const AccountBusinessInfoStaff = () => {
    const activeAccount = useAppSelector(selectCurrentProfile)?.account;

    const [editing, setEditing] = React.useState(false);

    const {data: company, isLoading: isCompanyLoading, error: companyError, refetch} = useGetCompanyQuery(activeAccount?.company_id);

    React.useEffect(() => {
        if (companyError) {
            const errorMessage = (companyError as BaseError)?.data?.message || (companyError as BaseError)?.error?.data?.message;
            showMessages(errorMessage, messageType.error);
        }
    }, [companyError]);

    // State used to open and close the child Modal.
    const onEdit = () => {
        setEditing(!editing);
    };

    // After a staff member completes editing company data, refresh the display.
    const handleCloseBusinessInfo = async () => {
        setEditing(false);
        // When the AccountBusinessInfoEdit route is updated to RTK and
        // invalidatesTags is set to 'Company', this refetch should be unnecessary.
        refetch();
    };

    return (
        <>
            <PageTitle title="Company Info"/>
            <Row gutter={{sm: 16}}>
                <Col {...cardsGridColumn}>
                    <Spin spinning={isCompanyLoading}>
                        <AccountBusinessDetailsStaff companyData={company || {}} onEdit={onEdit}/>
                    </Spin>
                </Col>
                <Col {...cardsGridColumn}>
                    <AddressCard contactableType="company"/>
                </Col>
            </Row>
            {
                company &&
                <AccountBusinessInfoEdit
                    companyDataProp={company}
                    isDrawerVisible={editing}
                    setDrawerVisible={handleCloseBusinessInfo}
                />
            }
        </>
    );
};

export default AccountBusinessInfoStaff;
